import { render, staticRenderFns } from "./DsTableTabs.vue?vue&type=template&id=5d9cbc69"
import script from "./DsTableTabs.vue?vue&type=script&lang=js"
export * from "./DsTableTabs.vue?vue&type=script&lang=js"
import style0 from "./DsTableTabs.vue?vue&type=style&index=0&id=5d9cbc69&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9cbc69')) {
      api.createRecord('5d9cbc69', component.options)
    } else {
      api.reload('5d9cbc69', component.options)
    }
    module.hot.accept("./DsTableTabs.vue?vue&type=template&id=5d9cbc69", function () {
      api.rerender('5d9cbc69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsTableTabs.vue"
export default component.exports